export const validTransitions = {
  'P': ['RECIBIDA'],
  'PCF': ['P'],
  'RECIBIDA': ['AUTORIZADO', 'NO_AUTORIZADO', 'DEVUELTA'],
  'NO_AUTORIZADO': ['RECIBIDA', 'P'],
  'DEVUELTA': ['P', 'RECIBIDA'],
  'AUTORIZADO': ['NOTIFICADO', 'NO_NOTIFICADO'],
  'NO_NOTIFICADO': ['NOTIFICADO'],
  'NOTIFICADO': []
}

export const statusLabels = {
  'P': 'Pendiente',
  'PCF': 'Pendiente Cambio de Fecha',
  'RECIBIDA': 'Recibida',
  'AUTORIZADO': 'Autorizada',
  'NO_AUTORIZADO': 'No Autorizada',
  'DEVUELTA': 'Devuelta',
  'NOTIFICADO': 'Notificada',
  'NO_NOTIFICADO': 'No Notificada'
}

export const getValidTransitions = (currentStatus) => {
  return validTransitions[currentStatus] || []
}
